module.exports = __webpack_public_path__ + "img/ios.10d041c5.png";